import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import MenuItem from '@material-ui/core/MenuItem';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { renderTextField, requiredValidator } from 'utils/formHelper';
import {
  fetchInvestor,
  updateInvestor,
  createInvestor
} from 'actions/investors';

const styles = {};

class Form extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false }
  };

  submit = (attrs) => {
    const { dispatch, investorId, mode } = this.props;
    let action;
    if (mode === 'create') {
      action = createInvestor(attrs);
    } else {
      action = updateInvestor({ id: investorId, ...attrs });
    }
    return dispatch(action)
      .then(this.handleClose)
      .catch(this.handleSubmitFailure);
  }

  handleSubmitFailure = (error) => {
    if (error && error.response) {
      throw new SubmissionError(error.response);
    }
  }

  handleClose = () => {
    this.setState({ open: false });
  }

  renderForm = () => {
    return (
      <div>
        <div className='form-row' >
          <Field
            name='firstName'
            component={renderTextField}
            label='First Name'
            validate={requiredValidator}
          />
        </div>
        <div className='form-row' >
          <Field
            name='lastName'
            component={renderTextField}
            label='Last Name'
            validate={requiredValidator}
          />
        </div>
        <div className='form-row' >
          <Field
            name='email'
            component={renderTextField}
            label="Email"
            validate={requiredValidator}
          />
        </div>
        <div className='form-row' >
          <Field
            name='phone'
            component={renderTextField}
            label='Phone'
            validate={requiredValidator}
          />
        </div>
        <div className='form-row' >
          <Field
            name='wechat'
            component={renderTextField}
            label='Wechat'
          />
        </div>
        <div className='form-row' >
          <Field
            name='manager'
            component={renderTextField}
            label='Manager'
          />
        </div>
        <div className='form-row' >
          <Field
            name='bankAccount'
            component={renderTextField}
            label='Bank account'
            multiline
          />
        </div>
        <div className='form-row' >
          <Field
            name='address'
            component={renderTextField}
            label='Address'
            multiline
          />
        </div>
        <div className='form-row' >
          <Field
            select
            name='locationType'
            component={renderTextField}
            label='Location type'
            validate={requiredValidator}
          >
            {
              [
                'Overseas',
                'Domestic',
              ].map(option => (
                <MenuItem key={option} value={option}>{option}</MenuItem>
              ))
            }
          </Field>
        </div>
        <div className='form-row' >
          <Field
            name='note'
            component={renderTextField}
            label='Note'
            multiline
          />
        </div>
      </div>
    );
  }

  title = () => {
    const { mode } = this.props;
    if (mode === 'create') {
      return 'Create Investor';
    } else {
      return 'Update Investor';
    }
  }

  render = () => {
    const { open } = this.state;
    const { handleSubmit, buttonLabel, buttonStyles, reset } = this.props;

    return (
      <div>
        <Button
          className={buttonStyles}
          color='primary'
          onClick={() => this.setState({ open: true })}
        >
          {buttonLabel}
        </Button>
        <Dialog
          open={open}
          onEnter={reset}
          onClose={this.handleClose}
        >
          <form onSubmit={ handleSubmit(this.submit) }>
            <DialogTitle>{this.title()}</DialogTitle>
            <DialogContent style={{ width: 500 }}>
              {this.renderForm()}
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose}>CANCEL</Button>
              <Button type='submit' color='primary'>SUBMIT</Button>
            </DialogActions>
          </form>
        </Dialog>
      </div>
    );
  };
}

const mapStateToProps = (state, ownProps) => {
  let initialValues = {}
  if (state.investors.investors && ownProps.investorId) {
    initialValues = state.investors.investors[ownProps.investorId];
  }
  return { initialValues };
};

const reduxed = reduxForm({ enableReinitialize: true })(Form);
const connected = connect(mapStateToProps)(reduxed);
export default withStyles(styles)(connected);



// WEBPACK FOOTER //
// ./src/components/Investors/Form.js